import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const CartCtx = createContext(null);
const KEY = "vaulted_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (p, qty = 1) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.product_id === p.id);
      const max = p.delivery_method === "download" ? 1 : 20;
      if (ex) return prev.map((i) => (i.product_id === p.id ? { ...i, quantity: Math.min(max, i.quantity + qty) } : i));
      return [...prev, { product_id: p.id, quantity: Math.min(max, qty), title: p.title, price: p.price, thumbnail: p.thumbnail,
        seller: p.seller?.store_name, delivery_method: p.delivery_method }];
    });
    toast.success("Added to cart", { description: p.title });
  };
  const setQty = (id, q) => setItems((prev) => prev.map((i) => (i.product_id === id ? { ...i, quantity: Math.max(1, Math.min(i.delivery_method === "download" ? 1 : 20, q)) } : i)));
  const remove = (id) => setItems((prev) => prev.filter((i) => i.product_id !== id));
  const clear = () => setItems([]);
  const replace = (list) => setItems(list);

  const count = useMemo(() => items.reduce((a, i) => a + i.quantity, 0), [items]);
  const total = useMemo(() => items.reduce((a, i) => a + i.quantity * i.price, 0), [items]);

  return <CartCtx.Provider value={{ items, add, setQty, remove, clear, replace, count, total }}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
